import React, { useState, useRef } from 'react';
import { useForm } from "react-hook-form";
import {
    DialogContent, DialogTitle, Dialog, IconButton,
    Paper, Radio, TextField, FormControlLabel, RadioGroup, Box, Grid,
    Button, MenuItem, FormControl, InputLabel, Select,
    Checkbox,
    Typography,
    Tooltip,
    Card
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { useLocation, useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { ERPinput, ERPinputNo } from '../../reusableComponent/ErpTextField';
import { addBank, addMailSetup, addUnit, editDeleteBank, editDeleteMailSetup, editDeleteUnit } from '../../../actions/actions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dateConversionOnEntryPage } from '../../reusableComponent/dateConversionOnEntryPage';
import styles from '.././../../styles.module.css';
import mail from '../../../images/mail5.jpg'
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import { BackBtn, Cancel } from '../../reusableComponent/BackBtn';

function MailsAdd(props) {
    const dispatch = useDispatch()
    const { handleSubmit } = useForm();

    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    // const editData = props.details;
    const urlLocation = useLocation();
    const editData = urlLocation.state;
    const editid = editData && editData.id;
    let navigate = useNavigate();
    const location = useLocation();

    const [successMessage, setSuccessMessage] = useState(null);
    const [open, setOpen] = React.useState(false);
    const [openSnak, setOpenSnak] = React.useState(false);

    const [data, setData] = useState({
        id: editid,
        email: editData ? editData.email : '',
        password: editData ? editData.password : '',
        services: editData ? editData.services : '',
        email_host: editData ? editData.email_host : '',
        port: editData ? editData.port : '',
        secure: editData ? editData.secure : '',
    });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        setOpen(false);
        setOpenSnak(false);
    };

    const handleOpenSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setData({
            unitName: '',
        })
        setOpenSnak(false);
        setOpen(false);
    }

    const handleCloseSnak = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnak(false);
    };

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
    }
    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.mailSetup.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'Email already available!') {
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                    setTimeout(() => {
                        setSuccessMessage(false)
                    }, 2000)

                } else {
                    setShouldShowMsg(true);
                    navigate(-1, { responseMessage });
                }
            }
        }
    }, [shouldShowMsg, responseMessage]);
    const onSubmit = (event) => {
        const mailData = {
            companyId: userInfo.companyId,
            ...data,
            createdBy: editData ? editData.createdBy : userInfo.userId,
            createdAt: editData ? editData.createdAt : dateConversionOnEntryPage(new Date()),
            modifiedBy: editData ? userInfo.userId : null,
            modifiedAt: editData ? dateConversionOnEntryPage(new Date()) : '',
            changedUpdatedValue: 'edit',
        }
        if (editData) {
            dispatch(editDeleteMailSetup(mailData));
        } else {
            dispatch(addMailSetup(mailData));
        }

        // props.onAPISubmt();
        // props.handleCloseDialog();
    }

    const action = (
        <React.Fragment>
            <Button size="small" id="btnYes" onClick={handleOpenSnack}>
                Yes
            </Button>
            <Button size="small" id="btnNo" onClick={handleCloseSnak}>
                No
            </Button>
        </React.Fragment>
    );

    return (
        <>
         <Breadcrumb
                            routeSegments={[
                                { name: 'Settings', path: '/settings' },
                                { name: 'Mail Setup List', path: '/mail-setups' },
                                { name: 'Create Mail Setup' },
                            ]}
                        />
            <div>
                <Paper className={`${styles.list_container}`}>
                   
                    {/* <Box sx={{ display: 'flex', paddingLeft: '50px', }}>
                        <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                            <Grid item md={12} xs={12}>
                                <Typography className={`${styles.page_title}`}>Create Mail Setup</Typography>
                            </Grid>
                        </Grid>
                    </Box> */}
                     <Box sx={{ m: 4}} > </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2} style={{ minHeight: '350px', paddingLeft: '50px' }}>
                            <Grid item xs={4}
                                style={{
                                    display: 'flex',
                                    alignItems: 'flex-end',
                                    backgroundImage: `url(${mail})`,
                                    backgroundRepeat: 'no-repeat',
                                    // backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    borderRight: '1px solid #c0c0c0',
                                }}
                            >    </Grid>
                            <Grid item xs={2} > </Grid>
                            <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                <Card className={`${styles.m_card}`}>
                                    <Grid container spacing={1} sx={{ mt: 0 }}>
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>Senders Email</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <ERPinput
                                                size='small'
                                                fullWidth
                                                type="email"
                                                onChange={handleChange}
                                                name="email"
                                                value={(data.email)}
                                            />
                                        </Grid>
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>Password</Typography>
                                        </Grid>
                                        <Grid item xs={8} >
                                            <ERPinput
                                                size='small'
                                                fullWidth
                                                type="password"
                                                onChange={handleChange}
                                                name="password"
                                                value={(data.password)}
                                            />
                                        </Grid>
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>Service</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <ERPinput
                                                size='small'
                                                fullWidth
                                                type="text"
                                                onChange={handleChange}
                                                name="services"
                                                value={(data.services)}
                                            />
                                        </Grid>
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>Email Host</Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <ERPinput
                                                size='small'
                                                fullWidth
                                                type="text"
                                                onChange={handleChange}
                                                name="email_host"
                                                value={(data.email_host)}
                                            />
                                        </Grid>
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>Port</Typography>
                                        </Grid>
                                        <Grid item xs={8} >
                                            <ERPinputNo
                                                size='small'
                                                fullWidth
                                                type="number"
                                                onChange={handleChange}
                                                name="port"
                                                value={(data.port)}
                                            />
                                        </Grid>
                                        <Grid item xs={4} className={`${styles.grid_lable}`}>
                                            <Typography className={`${styles.erp_lable}`}>Secure ? </Typography>
                                        </Grid>
                                        <Grid item xs={8} >
                                            <ERPinput
                                                select
                                                fullWidth
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="secure"
                                                value={(data.secure)}
                                                size='small'
                                                onChange={(e) => handleChange(e)}
                                            >
                                                <MenuItem value="true" className={`${styles.erp_lable}`}>true</MenuItem>
                                                <MenuItem value="false" className={`${styles.erp_lable}`}>false</MenuItem>
                                            </ERPinput>
                                        </Grid>
                                        <Grid item xs={12}> 
                                        <Box sx={{ marginTop: '12px', float: 'right' }}>
                                            <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                            <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                                            </Button>
                                            <Cancel />
                                        </Box>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        </Grid>
                    </form>
                </Paper>
                <Snackbar
                    open={openSnak}
                    autoHideDuration={4000}
                    onClose={handleCloseSnak}
                    message="Do you wish to close without saving ?"
                    action={action}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                />
                 {successMessage &&
                    <Snackbar
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        open={successMessage}
                        autoHideDuration={2000}
                        message={successMessage}
                    />
                }
            </div>
        </>
    )
}

export default MailsAdd